var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4180_3969)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3.33329 10.6667C3.33329 11.0349 3.63177 11.3334 3.99996 11.3334C4.36815 11.3334 4.66663 11.0349 4.66663 10.6667L4.66663 4.00004C4.66663 3.63185 4.36815 3.33337 3.99996 3.33337C3.63177 3.33337 3.33329 3.63185 3.33329 4.00004L3.33329 10.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.52864 9.52864C5.78899 9.26829 6.2111 9.26829 6.47145 9.52864C6.73179 9.78899 6.73179 10.2111 6.47145 10.4714L4.47145 12.4714C4.2111 12.7318 3.78899 12.7318 3.52864 12.4714L1.52864 10.4714C1.26829 10.2111 1.26829 9.78899 1.52864 9.52864C1.78899 9.26829 2.2111 9.26829 2.47145 9.52864L4.00004 11.0572L5.52864 9.52864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11.3333 5.33329C11.3333 4.9651 11.6318 4.66663 12 4.66663C12.3681 4.66663 12.6666 4.9651 12.6666 5.33329L12.6666 12C12.6666 12.3681 12.3681 12.6666 12 12.6666C11.6318 12.6666 11.3333 12.3681 11.3333 12V5.33329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5286 6.47136C13.789 6.73171 14.2111 6.73171 14.4714 6.47136C14.7318 6.21101 14.7318 5.7889 14.4714 5.52856L12.4714 3.52855C12.2111 3.26821 11.789 3.26821 11.5286 3.52855L9.52864 5.52856C9.26829 5.7889 9.26829 6.21101 9.52864 6.47136C9.78899 6.73171 10.2111 6.73171 10.4714 6.47136L12 4.94277L13.5286 6.47136Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4180_3969"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSort);
export default __webpack_public_path__ + "static/media/ic_sort.eb142d60b82c49a639300e7c41d857fa.svg";
export { ForwardRef as ReactComponent };